export const FeaturedAdActionType = {
  GET_FEATURED_AD_LIST: 'GET_FEATURED_AD_LIST',
  ADD_FEATURED_AD: 'ADD_FEATURED_AD',
  UPDATE_FEATURED_AD: 'UPDATE_FEATURED_AD',
  FEATURED_CONFIG: 'FEATURED_CONFIG',
};
